import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-top: 24px;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding: 16px;
  }

  @media (max-width: 480px) {
    padding: 12px;
    gap: 12px;
  }
`;

export const InfoPagina = styled.div`
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.c6b7280};
  font-weight: 500;
  text-align: center;
  flex-shrink: 0;

  @media (max-width: 768px) {
    text-align: center;
    order: 2;
  }

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

export const Controles = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 768px) {
    order: 1;
    justify-content: center;
    gap: 6px;
  }

  @media (max-width: 480px) {
    gap: 4px;
  }
`;

export const BotaoPagina = styled.button`
  padding: 8px 12px;
  border: 1px solid ${(props: any) => props.theme.colors.cd1d5db};
  background: ${(props: any) => props.theme.colors.white};
  color: ${(props: any) => props.theme.colors.c374151};
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 40px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;

  @media (max-width: 768px) {
    min-width: 36px;
    height: 32px;
    padding: 6px 10px;
    font-size: 13px;
  }

  @media (max-width: 480px) {
    min-width: 32px;
    height: 28px;
    padding: 4px 8px;
    font-size: 12px;
  }
  
  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
  
  &:focus {
    outline: none;
    ring: 2px;
    ring-color: ${(props: any) => props.theme.colors.cdc3545};
    ring-offset: 2px;
  }
`;

export const BotaoAtivo = styled(BotaoPagina)`
  && {
    background: ${(props: any) => props.theme.colors.cdc3545};
    border-color: ${(props: any) => props.theme.colors.cdc3545};
    color: ${(props: any) => props.theme.colors.pureWhite};
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
`;

export const BotaoDesabilitado = styled(BotaoPagina)`
  background: ${({theme}) => theme.colors.disabledBg};
  border-color: ${({theme}) => theme.colors.disabledBg};
  color: ${({theme}) => theme.colors.disabledText};
  cursor: not-allowed;
  opacity: 1;
  
  &:hover {
    background: ${({theme}) => theme.colors.disabledBg};
    border-color: ${({theme}) => theme.colors.disabledBg};
  }
`;

export const Separador = styled.span`
  padding: 8px 12px;
  color: ${(props: any) => props.theme.colors.c6b7280};
  font-size: 14px;
  font-weight: 500;
  min-width: 40px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media (max-width: 768px) {
    min-width: 36px;
    height: 32px;
    padding: 6px 10px;
    font-size: 13px;
  }

  @media (max-width: 480px) {
    min-width: 32px;
    height: 28px;
    padding: 4px 8px;
    font-size: 12px;
  }
`;
